module.exports = __webpack_public_path__ + "img/V-R-4-unload-connect-shadow.fddb00bb.png";